import moment from 'moment'
import { http } from 'services'
import layout from 'layouts/default'
import datepicker from 'components/datepicker'

var components = {
  layout: layout,
  datepicker: datepicker,
}

if (!isServer) {
  components.apexchart = require('vue-apexcharts')
}

var methods = {

  buildFpmParams: function (poolName) {
    var params = {}
    if (this.fpmFilter.from_date) {
      params.from_date = moment(this.fpmFilter.from_date, ['MM/DD/YYYY']).format('YYYY-MM-DD')
    }
    if (this.fpmFilter.to_date) {
      params.to_date = moment(this.fpmFilter.to_date, ['MM/DD/YYYY']).format('YYYY-MM-DD')
    }
    if (this.fpmFilter.from_time) params.from_time = this.fpmFilter.from_time
    if (this.fpmFilter.to_time) params.to_time = this.fpmFilter.to_time
    params.pool_name = poolName
    return params
  },

  fetchFpmLogs: async function () {
    this.fpmLoading = true
    try {
      var results = await Promise.all([
        http.get('php-fpm-logs', { params: this.buildFpmParams('www') }),
        http.get('php-fpm-logs', { params: this.buildFpmParams('www-psf') }),
      ])
      var dWww = results[0].data
      var dPsf = results[1].data
      this.fpmLogsWww = (dWww && dWww.data) ? dWww.data : (Array.isArray(dWww) ? dWww : [])
      this.fpmLogsPsf = (dPsf && dPsf.data) ? dPsf.data : (Array.isArray(dPsf) ? dPsf : [])
      this.renderFpmCharts()
    } catch (err) {
      this.fpmLogsWww = []
      this.fpmLogsPsf = []
      console.error('PHP-FPM logs fetch error', err)
    } finally {
      this.fpmLoading = false
    }
  },

  onFpmFilter: function () {
    this.fetchFpmLogs()
  },

  buildFpmSeriesAndOptions: function (list, title) {
    var dates = list.map(function (r) {
      return r.recorded_at ? moment(r.recorded_at).format('MM/DD HH:mm') : ''
    })
    var fullDates = list.map(function (r) {
      return r.recorded_at ? moment(r.recorded_at).format('YYYY-MM-DD HH:mm:ss') : ''
    })

    // Series shown by default on chart load
    var defaultVisible = ['Active', 'Max Active', 'Max Children Reached', 'Mem Free (MB)']

    var series = [
      { name: 'Active',                  data: list.map(function (r) { return r.active != null ? r.active : null }) },
      { name: 'Idle',                    data: list.map(function (r) { return r.idle != null ? r.idle : null }) },
      { name: 'Total',                   data: list.map(function (r) { return r.total != null ? r.total : null }) },
      { name: 'Max Active',              data: list.map(function (r) { return r.peak != null ? r.peak : null }) },
      { name: 'Listen Queue',            data: list.map(function (r) { return r.listen_queue != null ? r.listen_queue : null }) },
      { name: 'Max Listen Queue',        data: list.map(function (r) { return r.max_listen_queue != null ? r.max_listen_queue : null }) },
      { name: 'Max Children Reached',    data: list.map(function (r) { return r.max_children_reached != null ? r.max_children_reached : null }) },
      { name: 'FPM Total (MB)',          data: list.map(function (r) { return r.total_fpm_mem_mb != null ? Number(r.total_fpm_mem_mb) : null }) },
      { name: 'Avg Worker (MB)',         data: list.map(function (r) { return r.avg_worker_mem_mb != null ? Number(r.avg_worker_mem_mb) : null }) },
      { name: 'Max Worker (MB)',         data: list.map(function (r) { return r.max_worker_mem_mb != null ? Number(r.max_worker_mem_mb) : null }) },
      { name: 'Mem Used (MB)',           data: list.map(function (r) { return r.mem_used_mb != null ? Number(r.mem_used_mb) : null }) },
      { name: 'Mem Free (MB)',           data: list.map(function (r) { return r.mem_free_mb != null ? Number(r.mem_free_mb) : null }) },
      { name: 'Mem Used %',              data: list.map(function (r) { return r.mem_used_pct != null ? Number(r.mem_used_pct) : null }) },
    ]

    var options = {
      chart: {
        type: 'line',
        height: 340,
        zoom: { enabled: true },
        toolbar: { show: true },
        animations: { enabled: false },
        events: {
          mounted: function (chart) {
            series.forEach(function (s) {
              if (defaultVisible.indexOf(s.name) === -1) {
                chart.hideSeries(s.name)
              }
            })
          },
        },
      },
      title: { text: title, align: 'center' },
      stroke: {
        curve: 'smooth',
        width: 2,
        // dashed for: Max Active(3), Max Listen Queue(5), Max Worker(9)
        dashArray: [0, 0, 0, 6, 0, 6, 0, 0, 0, 6, 0, 0, 0],
      },
      xaxis: {
        categories: dates,
        labels: { rotate: -45, hideOverlappingLabels: true, style: { fontSize: '11px' } },
      },
      yaxis: [
        { seriesName: 'Active',               title: { text: 'Processes' }, min: 0, labels: { formatter: function (v) { return Math.round(v) } } },
        { seriesName: 'Idle',                 show: false },
        { seriesName: 'Total',                show: false },
        { seriesName: 'Max Active',           show: false },
        { seriesName: 'Listen Queue',         show: false },
        { seriesName: 'Max Listen Queue',     show: false },
        { seriesName: 'Max Children Reached', show: false },
        { seriesName: 'FPM Total (MB)',       opposite: true, title: { text: 'MB' }, labels: { formatter: function (v) { return v + ' MB' } } },
        { seriesName: 'Avg Worker (MB)',      opposite: true, show: false },
        { seriesName: 'Max Worker (MB)',      opposite: true, show: false },
        { seriesName: 'Mem Used (MB)',        opposite: true, show: false },
        { seriesName: 'Mem Free (MB)',        opposite: true, show: false },
        { seriesName: 'Mem Used %',           opposite: true, show: false },
      ],
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
      },
      tooltip: {
        shared: true,
        intersect: false,
        x: {
          formatter: function (val, opts) {
            var idx = opts && opts.dataPointIndex != null ? opts.dataPointIndex : 0
            return fullDates[idx] || String(val)
          },
        },
      },
    }

    return { series: series, options: options }
  },

  renderFpmCharts: function () {
    var wwwResult = this.buildFpmSeriesAndOptions(this.fpmLogsWww || [], 'PHP-FPM Workers & Memory — www')
    this.fpmSeriesWww = wwwResult.series
    this.fpmChartOptionsWww = wwwResult.options

    var psfResult = this.buildFpmSeriesAndOptions(this.fpmLogsPsf || [], 'PHP-FPM Workers & Memory — www-psf')
    this.fpmSeriesPsf = psfResult.series
    this.fpmChartOptionsPsf = psfResult.options
  },

  formatDate: function (val) {
    return val ? moment(val).format('YYYY-MM-DD HH:mm') : '-'
  },

  formatNum: function (val) {
    return val != null ? Number(val).toFixed(2) : '-'
  },
}

export default {
  name: 'server-health',
  components: components,
  methods: methods,
  computed: {
    timeOptions: function () {
      var opts = []
      for (var h = 0; h < 24; h++) {
        var hh = String(h).padStart(2, '0')
        opts.push(hh + ':00')
        opts.push(hh + ':30')
      }
      opts.push('23:59')
      return opts
    },
  },
  data: function () {
    var snapFloor = function (m) {
      return m.minutes() < 30
        ? m.format('HH') + ':00'
        : m.format('HH') + ':30'
    }
    var snapCeil = function (m) {
      if (m.minutes() === 0) return m.format('HH') + ':00'
      if (m.minutes() <= 30) return m.format('HH') + ':30'
      return m.clone().add(1, 'hour').startOf('hour').format('HH') + ':00'
    }
    var toUtc = moment().utc()
    var fromUtc = toUtc.clone().subtract(3, 'hours')
    return {
      fpmLoading: false,
      fpmLogsWww: [],
      fpmLogsPsf: [],
      fpmChartOptionsWww: {},
      fpmChartOptionsPsf: {},
      fpmSeriesWww: [],
      fpmSeriesPsf: [],
      fpmFilter: {
        from_date: fromUtc.format('MM/DD/YYYY'),
        to_date: toUtc.format('MM/DD/YYYY'),
        from_time: snapFloor(fromUtc),
        to_time: snapCeil(toUtc),
      },
    }
  },
  mounted: function () {},
}
